new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if (bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if (bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    }

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if(firstCarrousel) {
            $('#product_list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".product-list-arrows .prev"),
                nextArrow: $(".product-list-arrows .next"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const secondCarrousel = element.querySelector('#product_list2');
        if(secondCarrousel) {
            $('#product_list2').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".product-list-arrows .prev2"),
                nextArrow: $(".product-list-arrows .next2"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list2').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.third-vitrine').then(element => {
        const thirdCarrousel = element.querySelector('#product_list3');
        if(thirdCarrousel) {
            $('#product_list3').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".product-list-arrows .prev3"),
                nextArrow: $(".product-list-arrows .next3"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list3').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.fourth-vitrine').then(element => {
        const fourthCarrousel = element.querySelector('#product_list4');
        if(fourthCarrousel) {
            $('#product_list4').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".product-list-arrows .prev4"),
                nextArrow: $(".product-list-arrows .next4"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list4').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.fifth-vitrine').then(element => {
        const fifthCarrousel = element.querySelector('#product_list5');
        if(fifthCarrousel) {
            $('#product_list5').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".product-list-arrows .prev5"),
                nextArrow: $(".product-list-arrows .next5"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list5').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.sixth-vitrine').then(element => {
        const sixthCarrousel = element.querySelector('#product_list6');
        if(sixthCarrousel) {
            $('#product_list6').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".product-list-arrows .prev6"),
                nextArrow: $(".product-list-arrows .next6"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list6').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.seventh-vitrine').then(element => {
        const seventhCarrousel = element.querySelector('#product_list7');
        if(seventhCarrousel) {
            $('#product_list7').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                prevArrow: $(".product-list-arrows .prev7"),
                nextArrow: $(".product-list-arrows .next7"),
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            dots: false,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1249,
                        settings: {
                            dots: false,
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('#product_list7').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.faixa-comunicado').then(element => { 
        const faixaComunicadoList = document.querySelector('.faixa-comunicado-list');
        if(faixaComunicadoList) {
            $('.faixa-comunicado-list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: false,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: 'unslick'
                    },
                ]
            });
        }
    });

    waitForElementToExist('#brands-carousel').then(element => {
        $('#brands-carousel').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            autoplay: true, 
            autoplaySpeed: 2000,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 7,
                        slidesToShow: 7,
                    }
                },
            ]
        });
    });

    waitForElementToExist('.banner-info').then(element => {
        $('.banner-info').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                },
            ]
        });
    });

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if(productRatings) {
            $('.product-ratings-list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: false,
                dots: false,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 2000,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToShow: 3,
                            dots: false,
                            adaptiveHeight: true,
                        }
                    },
                ]
            });

            $('.product-ratings-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.banner-category-list').then(element => {
        $('.banner-category-list').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                },
            ]
        });
    });

});